import React from 'react';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import { string, number, bool, func } from 'prop-types';

const propTypes = {
    status: number.isRequired,
    label: string.isRequired,
    onChange: func.isRequired,
    checked: bool,
};
const defaultProps = {
    onChange() { },
    checked: false,
};

const FlowPostbackStatus = ({ status, label, checked, onChange }) => (
    <li className="flow-postback-statuses-item">
        <CustomControl
            id={`postback-status-${status}`}
            label={label}
            className="custom-control-xs"
            value={status}
            id={`postback-status-${status}`}
            checked={checked}
            onChange={onChange}
        />
    </li>
);

FlowPostbackStatus.propTypes = propTypes;
FlowPostbackStatus.defaultProps = defaultProps;

export default FlowPostbackStatus;